<template lang="pug">
div
  div
    select(v-model='type')
      option
      option(value='schools') écoles
      option(value='colleges') colléges
    input(type='text', placeholder='ajout', v-model='name')
    input(type='submit', @click='addEstablishment')
    p.error(v-html='error')
  #establishmentList
    div
      h1 écoles
      div(v-for='(establishment, index) in establishments', :key='index')
        p(v-if='establishment.schools  != null')
          | {{establishment | getNAme}}
          span(@click='removeEstablishment(establishment.id)')
            i.far.fa-trash-alt
    div
      h1 Colléges
      div(v-for='(establishment, index) in establishments', :key='index')
        p(v-if='establishment.colleges != null')
          | {{establishment | getNAme}}
          span(@click='removeEstablishment(establishment.id)')
            i.far.fa-trash-alt
</template>

<script>
import axios from 'axios'
let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

export default {
  data() {
    return {
      type: '',
      name: '',
      error: '',
      establishments: [],
    }
  },
  filters: {
    getNAme(value) {
      return value.schools != null ? value.schools : value.colleges
    },
  },
  mounted() {
    this.getEstablishment()
  },
  methods: {
    async removeEstablishment(id) {
      let data = JSON.stringify({
        id: id,
      })

      let url = `${BACK_END_PATH}/removeEstablishments`

      await axios({
        method: 'post',
        url,
        data,
      }).then(() => {
        this.getEstablishment()
      })
    },
    async getEstablishment() {
      await axios.get(`${BACK_END_PATH}/allEstablishments`).then(r => {
        this.establishments = r.data
      })
    },
    async addEstablishment() {
      this.error = ''
      if (this.type.length > 0 && this.name.length > 0) {
        let data = JSON.stringify({
          name: this.name,
          type: this.type,
        })

        let url = `${BACK_END_PATH}/addEstablishment`

        await axios({
          method: 'post',
          url,
          data,
        }).then(() => {
          // console.log(r)
          this.getEstablishment()
        })
      } else {
        this.error +=
          this.type.length > 0 ? '' : "choisir un type d'établissemment <br>"
        this.error +=
          this.name.length > 0 ? '' : "entrer un nom d'établissement"
      }
    },
  },
}
</script>


<style>
#establishmentList h1 {
  text-align: center;
}
#establishmentList {
  height: 80vh;
  overflow: auto;
  background: white;
  padding: 5px;
  display: flex;
  justify-content: space-around;
}
#establishmentList p span:hover {
  color: red;
}
#establishmentList p span {
  cursor: pointer;
}
</style>
